import { render } from "./Calc.vue?vue&type=template&id=de280962&scoped=true&ts=true"
import script from "./Calc.vue?vue&type=script&lang=ts"
export * from "./Calc.vue?vue&type=script&lang=ts"

import "./Calc.vue?vue&type=style&index=0&id=de280962&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de280962"]])

export default __exports__